import { useCallback } from 'react'
import { useAppStore } from '~/stores/app'
import { useAuthStore } from '~/stores/auth'
import { useSessionStore } from '~/stores/session'
import { useSettingsStore } from '~/stores/settings'

export function useResetState() {
  const reset = useCallback(() => {
    useAuthStore.getState().resetState()
    useSessionStore.getState().resetState()
    useSettingsStore.getState().resetState()
    useAppStore.getState().resetState()
  }, [])

  return { reset }
}
